import { format, parseISO, lastDayOfMonth, subMonths, isBefore } from 'date-fns';
import _ from 'lodash';
export * from 'date-fns';

export const previousMonth = () => {
  const now = new Date();
  return subMonths(now, 1);
};

export const lastDayOfPreviousMonth = () => {
  const month = previousMonth();
  return lastDayOfMonth(month);
};

export const formatDate = (date, dateFormat = 'yyyy-MM-dd', iso = false) => {
  if (!date) return '';

  const parsedDate = iso ? parseISO(date) : date;
  return format(parsedDate, dateFormat);
};

export const firstDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const objectToDate = (obj) => {
  const { year, month, day = 0 } = obj;
  if (!year || !month) return null;

  return new Date(year, month, day);
};

export const isBeforeToday = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const sourceDate = _.isDate(date) ? date : new Date(date);
  return isBefore(sourceDate, today);
};
